import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";

const PrintOptionPageHeader: FunctionComponent = observer(function PrintOptionPageHeader(props) {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options: {
			printHeader,
		},
		setPrintHeader,
	} = optionsStore; 

	return (
		<>
			{isDefined(printHeader) && (
				<CheckboxOption
					label="CustomViewIncludePageHeader"
					onChange={setPrintHeader}
					optionValue={printHeader}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default PrintOptionPageHeader;